<template>
  <nav class="tw-container tw-p-4 sm:tw-py-6">
    <ol
      class="tw-flex tw-min-w-0 tw-items-center tw-gap-1 tw-overflow-hidden tw-text-[14px] tw-leading-[20px]"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        class="tw-flex tw-max-w-[300px] tw-items-center tw-shrink-0 tw-whitespace-nowrap"
        :class="index === items.length - 1 ? 'tw-min-w-0 tw-flex-1' : ''"
      >
        <template v-if="index === 0">
          <NuxtLink
            :to="item.path"
            class="tw-block tw-max-w-[300px] tw-truncate tw-text-secondary hover:tw-text-primary tw-transition-colors"
          >
            {{ item.title }}
          </NuxtLink>
        </template>
        <template v-else>
          <span class="tw-text-dark-gray">/</span>
          <template v-if="index === items.length - 1">
            <span class="tw-min-w-0 tw-flex-1 tw-truncate tw-pl-1 tw-text-dark-gray">
              {{ item.title }}
            </span>
          </template>
          <template v-else>
            <NuxtLink
              :to="item.path"
              class="tw-block tw-max-w-[300px] tw-truncate tw-pl-1 tw-text-secondary hover:tw-text-primary tw-transition-colors"
            >
              {{ item.title }}
            </NuxtLink>
          </template>
        </template>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
defineProps<{
  items: BreadCrumb[];
}>();
</script>
